// Unpublished Work © 2021-2024 Deere & Company.

import React from 'react';

const BACKGROUND_COLOR_STYLE = {
    style: {
        backgroundColor: '#E5E5E5'
    }
};

function MainContentBackground() {
    return (
        <div
            {...BACKGROUND_COLOR_STYLE}
            className='main-content-background'
            data-testid='main-content-background'
        />
    );
}

export default MainContentBackground;
